import i18n from '@dms/i18n';

import {RentalVehicle} from '../../core/types/RentalVehicle';
import {Field} from './primitives/Field';

export function RentalAvailabilityFromDatePicker() {
  return (
    <Field<RentalVehicle, 'apiDate'>
      type="apiDate"
      name="rentalProperties.availability.from"
      label={i18n.t('entity.rental.labels.createFrom')}
    />
  );
}
